/** Validate a VIN */
export const validateVin = (vin?: string | null) => {
  if (!vin) return false;

  vin = vin.toLowerCase();
  if (!/^[a-hj-npr-z0-9]{8}[0-9xX][a-hj-npr-z0-9]{8}$/.test(vin)) {
    return false;
  }

  const transliterationTable = {
    '0': 0,
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4,
    '5': 5,
    '6': 6,
    '7': 7,
    '8': 8,
    '9': 9,
    a: 1,
    b: 2,
    c: 3,
    d: 4,
    e: 5,
    f: 6,
    g: 7,
    h: 8,
    j: 1,
    k: 2,
    l: 3,
    m: 4,
    n: 5,
    p: 7,
    r: 9,
    s: 2,
    t: 3,
    u: 4,
    v: 5,
    w: 6,
    x: 7,
    y: 8,
    z: 9,
  };

  const weightsTable = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum = 0;

  for (let i = 0; i < vin.length; ++i) {
    sum += transliterationTable[vin.charAt(i)] * weightsTable[i];
  }

  const mod = sum % 11;
  return mod === 10 ? vin.charAt(8) === 'x' : vin.charAt(8) == mod;
};

/** Validate a phone number */
export const validatePhone = (phone?: string | null) => {
  if (!phone) return false;
  return /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone);
};

/** Validate an email address */
export const validateEmail = (email?: string | null) => {
  if (!email) return false;
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};

/** Maximum display name length */
export const MAX_DISPLAY_NAME_LENGTH = 32;

/** Validate a display name (non-empty, within max length) */
export const validateDisplayName = (name?: string | null) => {
  if (!name) return false;
  return name.length > 0 && name.length <= MAX_DISPLAY_NAME_LENGTH;
};
